import React, { useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";
import ManditoryStar from "../../templates/ManditoryStar";

const AdminDiscoverSection = () => {
  const [discoverText, setDiscoverText] = useState({
    heading: "",
    description: "",
  });

  const [inputDisble, setInputDisble] = useState(true);
  const [id, setId] = useState(null);

  const { data,isLoading } = useQuery({
    queryKey: "getallprocess",
    queryFn: () =>
      axios.get(`${BASEURL}process`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setDiscoverText({
        heading: response[0].heading,
        description: response[0].description,
      });
      setId(response[0].id);
    },
  });

  const editMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}process/${id}`,values);
    },
     onSuccess: () => {
          Swal.fire({
            title: "Updated Successfully",
            icon: "success",
            draggable: false,
            // confirmButtonColor:"#fcd70c",
            customClass: {
              confirmButton: "custom-confirm-button", // Add a custom class for styling
            },
          })
        },
  });

  const handleUpdate = (e) => {
    e.preventDefault();
    const values = {
      heading: discoverText.heading,
      description: discoverText.description,
    };
    editMutation.mutate(values);
  };

  const handleChange = (e) => {
    let newdata = { ...discoverText };

    newdata[e.target.name] = e.target.value;
    setDiscoverText(newdata);
  };

  const handleCancel = () => {
    setInputDisble(true);
  };
  return (
    <div>
      {(isLoading || editMutation.isLoading) && <TraingleLoading />}

      <div className="flex justify-between items-center">
        <AdminTabelHeader
          title={inputDisble ? "Discover Section" :"Discover Section Edit"}
          btnname={"Edit Section"}
          btnStatus={false}
        />
        <button
          onClick={inputDisble ? () => setInputDisble(false) : handleCancel}
          type="button"
          class="button"
        >
          <div class="button-top">{inputDisble ? "Edit" : "Cancel"}</div>
          <div class="button-bottom"></div>
          <div class="button-base"></div>
        </button>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
          <ManditoryStar title={"title"} />

            <input
              name="heading"
              className={`input `}
              value={discoverText.heading}
              type="text"
              placeholder="Enter your name"
              onChange={(e) => handleChange(e)}
              disabled={inputDisble}

            />
          </div>

          <div>
          <ManditoryStar title={"content"} />

            <textarea
              name="description"
              className={`textarea  `}
              value={discoverText.description}
              onChange={(e) => handleChange(e)}
              disabled={inputDisble}

            />
          </div>
        </div>
        {!inputDisble && (
          <div className="flex justify-end my-4 ">
            
            <button onClick={(e) => handleUpdate(e)} className="formSubmit">
              Update
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDiscoverSection;
